module.exports = fox._r("htmlplayer/fonts/acplayer.woff?9g9mys", __webpack_public_path__ + "_/_/_/_/common-components/htmlplayer/fonts/2NYhB3v.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/fonts/acplayer.woff?9g9mys
// module id = 564
// module chunks = 4